var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "status error"
  }, [_vm.coins_purchased && _vm.imageIndex !== -1 ? _c('img', {
    attrs: {
      "src": ("/assets/images/shop/icons/coins-" + (_vm.imageIndex + 1) + "x.png"),
      "alt": "treasure"
    }
  }) : _vm.gems_purchased && _vm.imageIndex !== -1 ? _c('img', {
    attrs: {
      "src": ("/assets/images/shop/icons/gems-" + (_vm.imageIndex + 1) + "x.png"),
      "alt": "treasure"
    }
  }) : _c('img', {
    attrs: {
      "src": "/assets/images/shop/icons/treasure.png",
      "alt": "treasure"
    }
  }), _c('h3', [_vm._v("Sorry!")]), _c('p', [_vm._v("Something went wrong. Please try again.")]), _c('svg', {
    staticClass: "animated-icon",
    attrs: {
      "width": "90",
      "height": "90",
      "viewBox": "0 0 90 90",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    staticClass: "circle",
    attrs: {
      "cx": "45",
      "cy": "45",
      "r": "45",
      "fill": "#DA2E2E"
    }
  }), _c('path', {
    staticClass: "line",
    attrs: {
      "d": "M45 24L45 54.1351",
      "stroke": "white",
      "stroke-width": "8",
      "stroke-linecap": "round"
    }
  }), _c('path', {
    staticClass: "dot",
    attrs: {
      "d": "M45 66.8232H45.0001",
      "stroke": "white",
      "stroke-width": "8",
      "stroke-linecap": "round"
    }
  })]), _c('button', {
    staticClass: "btn btn-dark",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.redirectToHome
    }
  }, [_vm._v(" Ok ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }